import { render, staticRenderFns } from "./OreActionPlan.vue?vue&type=template&id=bb6b642a&scoped=true"
import script from "./OreActionPlan.vue?vue&type=script&lang=js"
export * from "./OreActionPlan.vue?vue&type=script&lang=js"
import style0 from "./OreActionPlan.vue?vue&type=style&index=0&id=bb6b642a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6b642a",
  null
  
)

export default component.exports